import { createStore, createLogger } from 'vuex'
import organisations from './modules/organisations'
import services from './modules/services'
import projects from "@/Store/modules/projects";
import expenses from "@/Store/modules/expenses";
import supplierinvoice from "@/Store/modules/supplierinvoice";
import offices from "@/Store/modules/offices";
import bankaccounts from "@/Store/modules/bankaccounts"
import users from "@/Store/modules/users"
import global from "@/Store/modules/global";

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    modules: {
        organisations,
        services,
        projects,
        expenses,
        supplierinvoice,
        offices,
        bankaccounts,
        users,
        global
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
